import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Logo" }
const _hoisted_2 = ["src"]

import { computed } from "vue";
import { useCompanyStore } from "@/stores/company";


export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    size: {
        type: Number,
        default: 10,
    },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "07620ae4": (__props.size)
}))



const companyStore = useCompanyStore();

const company = computed(() => companyStore.company);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: company.value?.logoUrl,
      alt: "Logo"
    }, null, 8, _hoisted_2)
  ]))
}
}

})